module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyOS4zMDUgMjkuMzA1Ij4KICA8ZGVmcz4KICAgIDxzdHlsZT4KICAgICAgLmNscy0xIHsKICAgICAgICBmaWxsOiAjZDYzOTM5OwogICAgICB9CiAgICA8L3N0eWxlPgogIDwvZGVmcz4KICA8cGF0aCBpZD0iSWNvbl9XYXJuaW5nIiBjbGFzcz0iY2xzLTEiIGQ9Ik0xNC42NTIsMEExNC42NTIsMTQuNjUyLDAsMSwwLDI5LjMsMTQuNjUyLDE0LjcsMTQuNywwLDAsMCwxNC42NTIsMFptMi4wMTUsMjIuMzQ1SDEyLjYzOHYtMy40OEgxNi44NXYzLjQ4Wk0xNi44NSw4Ljc5MWwtMS4xLDguMDU5aC0yLjJsLTEuMS04LjA1OVY2Ljk2aDQuNTc5VjguNzkxWiIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/warning.svg
// module id = 221
// module chunks = 1